import { Col, FormCheck, FormControl, FormLabel, FormSelect, Row } from "react-bootstrap";
import { useState } from "react";
import RollDice, { RollDiceSummed } from "../dice-rolling";

export default function RammingAndOarRakes() {
	const [isRamAttack, setIsRamAttack] = useState(true);

	// Success Table cell determination numbers (1 based)
	const [attackersSizeRating, setAttackersSizeRating] = useState(1);
	const [targetSizeRating, setTargetSizeRating] = useState(1);

	// Attacker Ram Value
	const [ramValue, setRamValue] = useState(1);
	const [ramModifier, setRamModifier] = useState(0);
	const [isNoRamShip, setIsNoRamShip] = useState(false);

	// Common DRMs
	const [attackingExperience, setAttackingExperience] = useState("IX");
	const [targetSpeed, setTargetSpeed] = useState(0);
	const [isDrifting, setIsDrifting] = useState(false);
	// Common success DRMs
	const [isGrappledOrD, setIsGrappledOrD] = useState(false);
	const [isC, setIsC] = useState(false);
	// Common Successful DRMs
	const [attackersMoveRate, setAttackersMoveRate] = useState("Maneuver");

	// Ram Specific DRMs
	const [ramAttackDir, setRamAttackDir] = useState("Side");
	// Ram specific success DRMs
	const [isRamWithoutDeckCrew, setIsRamWitoutDeckCrew] = useState(false);

	// Oar Rake specific DRMs
	const [isSternRake, setIsSternRake] = useState(false);
	// Oar Rake specific success DRMs
	const [targetExperience, setTargetExperience] = useState("IX");


	const [results, setResults] = useState({ target: "", attacker: "", ram: true});


	// Tables
	const attackSuccessTable: number[][] = [
		[6, 5, 4, 3, 3],
		[7, 6, 5, 4, 3],
		[8, 7, 6, 5, 4],
		[9, 8, 7, 6, 5],
		[9, 9, 8, 7, 6]
	];
	const successfulRamTable: number[] = [4, 5, 5, 5, 6, 6, 6, 7, 7, 8];
	const unsuccessfulRamTable: number[] = [1, 2, 2, 3, 3, 3, 3, 3, 3, 3];
	const successfulRakeTable: number[] = [4, 4, 5, 5, 5, 5, 5, 6, 6, 7];
	const unsuccessfulRakeTable: number[] = [1, 2, 3, 3, 3, 3, 3, 3, 3, 3];


	// Table Roll Methods
	function rollForAttackSuccess(): boolean {
		// Get threshold from attackSuccessTable.
		// The attackersSizeRating is the Rows and the targetsSizeRating is the columns.
		// Both are base 1 values.
		const threshold: number = attackSuccessTable[attackersSizeRating - 1][targetSizeRating - 1];

		// Determine DRMs
		let drms: number = 0;

		if (isGrappledOrD)
			drms += 2;
		else if (isDrifting || isC)
			drms += 1;

		if (attackingExperience === "VT")
			drms += 2;
		else if (attackingExperience === "IX")
			drms -= 2;

		if (isRamAttack) {
			if (ramAttackDir === "Front")
				drms -= 2;
			else if (ramAttackDir === "Stern") {
				if (targetSpeed === 0)
					drms -= 2
				else if (targetSpeed >= 1 && targetSpeed <= 3)
					drms -= 3;
				else
					drms -= 4;
			}

			if (isRamWithoutDeckCrew)
				drms -= 1;
		} else {
			if (targetExperience === "EX")
				drms -= 1;
			else if (targetExperience === "VT")
				drms -= 2;

			if (isSternRake)
				drms -= 1;
		}

		// Roll and Modify Die
		const modifiedDieRoll: number = RollDice(1)[0] + drms;

		// Return Result
		return modifiedDieRoll >= threshold;
	}

	function rollRamSucessful(): { target: string, attacker: string } {
		// Determin DRMs
		let drms: number = 0;

		if (attackingExperience === "VT")
			drms += 1;
		else if (attackingExperience === "IX")
			drms -= 1;

		if (ramAttackDir === "Bow")
			drms -= 1;
		else if (ramAttackDir === "Stern")
			drms += 1;

		if (attackersMoveRate === "Maneuver")
			drms -= 1;
		else if (attackersMoveRate === "Ram")
			drms += 1;

		// Roll and Modify Die
		const modifiedDieRoll: number = RollDice(1)[0] + drms;

		// Determine Result
		const result: number = successfulRamTable[modifiedDieRoll - 1];

		// Create and return results string
		return RamResults(result);
	}

	function rollRamFailed(): { target: string, attacker: string } {
		// Determin DRMs
		let drms: number = 0;

		if (attackingExperience === "VT")
			drms += 1;
		else if (attackingExperience === "IX")
			drms -= 1;

		if (ramAttackDir === "Bow")
			drms -= 1;
		else if (ramAttackDir === "Stern")
			drms += 1;

		// Roll and Modify Die
		const modifiedDieRoll: number = RollDice(1)[0] + drms;

		// Determine Result
		const result = unsuccessfulRamTable[modifiedDieRoll - 1];

		// Create and return results string
		return RamResults(result);
	}

	function rollOarRakeSucessful(): { target: string, attacker: string } {
		// Determine DRMs
		let drms: number = 0;

		if (attackingExperience === "VT")
			drms += 1;
		else if (attackingExperience === "IX")
			drms -= 1;

		if (!(targetSpeed === 0 || isDrifting)) {
			if (!isSternRake)
				drms += 1;
			else if (targetSpeed <= 3)
				drms -= 1;
			else
				drms -= 2;
		}

		if (attackersMoveRate === "Maneuver")
			drms -= 1;
		else if (attackersMoveRate === "Ram")
			drms += 1;

		// Roll and Modify Die
		const modifiedDieRoll: number = RollDice(1)[0] + drms;

		// Determine Result
		const result: number = successfulRakeTable[modifiedDieRoll - 1];

		// Create and return results string
		return RakeResults(result);
	}

	function rollOarRakeFailed() {
		// Determine DRMs
		let drms: number = 0;

		if (attackingExperience === "VT")
			drms = 1;
		else if (attackingExperience === "IX")
			drms = -1;

		// Roll and Modify Die
		const modifiedDieRoll = RollDice(1)[0] + drms;

		// Determine Result
		const result = unsuccessfulRakeTable[modifiedDieRoll - 1];

		// Create and return results string
		return RakeResults(result);
	}


	// Results Creation Methods
	function RamResults(result: number): { target: string, attacker: string } {
		var hullDamage: number;
		var oarDamage: number;
		var results: { target: string, attacker: string } = { target: "", attacker: "" };

		switch (result) {
			case 1:
				hullDamage = RollDiceSummed(ramValue <= 2 ? ramValue : 2) + ramModifier;
				oarDamage = RollDice(1)[0];
				results.attacker = `Attacker takes ${hullDamage} Hull Damage plus ${oarDamage} Oar Damage; attacker loses ram`;
				break;
			case 2:
				hullDamage = RollDiceSummed(ramValue <= 2 ? ramValue : 2) + ramModifier;
				oarDamage = RollDice(1)[0];
				results.attacker = `Attacker takes ${hullDamage} Hull Damage plus ${oarDamage} Oar Damage`;
				hullDamage = RollDiceSummed(ramValue <= 2 ? ramValue : 2) + ramModifier;
				oarDamage = RollDice(1)[0];
				results.target = `Target takes ${hullDamage} Hull Damage plus ${oarDamage} Oar Damage`;
				break;
			case 3:
				results = { attacker: "No Damage", target: "No Damage" };
				break;
			case 4:
				hullDamage = Math.floor((RollDiceSummed(ramValue) + ramModifier) / 2);
				results.target = `Target takes ${hullDamage} Hull Damage`;

				if (isNoRamShip) {
					hullDamage = Math.floor((RollDiceSummed(ramValue) + ramModifier) / 2);
					results.attacker = `Attacker takes ${hullDamage} Hull Damage`;
				}
				break;
			case 5:
				hullDamage = RollDiceSummed(ramValue) + ramModifier;
				results.target = `Target takes ${hullDamage} Hull Damage`;

				if (isNoRamShip) {
					hullDamage = RollDiceSummed(ramValue) + ramModifier;
					results.attacker = `Attacker takes ${hullDamage} Hull Damage`;
				}
				break;
			case 6:
				hullDamage = RollDiceSummed(ramValue + 1) + ramModifier;
				results.target = `Target takes ${hullDamage} Hull Damage, 2 Oar Damage and 1 Rowing Crew Loss; Target Drifts (place a DRIFT marker on target ship)`;

				if (isNoRamShip) {
					hullDamage = RollDiceSummed(ramValue + 1) + ramModifier;
					results.attacker = `Attacker takes ${hullDamage} Hull Damage, 2 Oar Damage and 1 Rowing Crew Loss; Attacker Drifts (place a DRIFT marker on attacking ship)`;
				}
				break;
			case 7:
				hullDamage = RollDiceSummed(ramValue + 2) + ramModifier;
				results.target = `Target takes ${hullDamage} Hull Damage, 4 Oar Damage and 2 Rowing Crew Loss; Target Drifts (place a DRIFT marker on target ship)`

				if (isNoRamShip) {
					hullDamage = RollDiceSummed(ramValue + 2) + ramModifier;
					results.attacker = `Attacker takes ${hullDamage} Hull Damage, 4 Oar Damage and 2 Rowing Crew Loss; Attacker Drifts (place a DRIFT marker on attacking ship)`
				}
				break;
			default: // only posibility here is 8
				hullDamage = RollDiceSummed(ramValue + 3) + ramModifier;
				results.target = `Target takes ${hullDamage} Hull Damage, 6 Oar Damage and 3 Rowing Crew Loss; Target Drifts (place a DRIFT marker on target ship)`

				if (isNoRamShip) {
					hullDamage = RollDiceSummed(ramValue + 3) + ramModifier;
					results.attacker = `Attacker takes ${hullDamage} Hull Damage, 6 Oar Damage and 3 Rowing Crew Loss; Attacker Drifts (place a DRIFT marker on attacking ship)`
				}
				break;
		}

		return results;
	}

	function RakeResults(result: number): { target: string, attacker: string } {
		let oarDamage: number = 0;
		let results: { target: string, attacker: string } = { target: "", attacker: "" };

		switch (result) {
			case 1:
				results.attacker = `Attacker takes ${RollDiceSummed(2)} Oar Damage and must Drift`;
				break;
			case 2:
				results.attacker = `Attacker takes ${RollDiceSummed(1)} Oar Damage and must Drift`;
				break;
			case 3:
				results.attacker = "No Damage";
				results.target = "No Damage";
				break;
			case 4:
				results.attacker = `Attacker takes ${RollDiceSummed(1)} Oar Damage and must Drift`;
				results.target = `Target takes ${RollDiceSummed(1)} Oar Damage and must Drift`;
				break;
			case 5:
				oarDamage = RollDiceSummed(ramValue) + ramModifier;
				results.target = `Target takes ${oarDamage} Oar Damage plus for every 4 points of Oar Factors destroyed, 1 Rowing Crew is slain.`
				break;
			case 6:
				oarDamage = RollDiceSummed(ramValue) + ramModifier;
				results.target = `Target takes ${oarDamage} Oar Damage plus for every 3 points of Oar Factors destroyed, 1 Rowing Crew is slain.`
				break;
			default: // only posibility here is 7
				oarDamage = RollDiceSummed(ramValue) + ramModifier;
				results.target = `Target takes ${oarDamage} Oar Damage plus for every 2 points of Oar Factors destroyed, 1 Rowing Crew is slain.`
				break;
		}

		return results;
	}


	// Roll Event Handler
	function rollforAttack() {
		let results: { target: string, attacker: string } = { target: "", attacker: "" };

		if (rollForAttackSuccess()) {
			if (isRamAttack)
				results = rollRamSucessful();
			else
				results = rollOarRakeSucessful();
		} else {
			if (isRamAttack)
				results = rollRamFailed();
			else
				results = rollOarRakeFailed();
		}

		setResults({target: results.target, attacker: results.attacker, ram: isRamAttack});
	}

	return (
		<>
			<Row>
				<Col>
					<h1>Ramming and Oar Rake Attacks</h1>
				</Col>
			</Row>
			{results.attacker === "" ? null : (
				<Row className="p-3 text-center">
					<Col>
						<h3>{results.attacker}</h3>
					</Col>
				</Row>
			)}
			{results.target === "" ? null : (
				<Row className="p-3 text-center">
					<Col>
						<h3>{results.target}</h3>
					</Col>
				</Row>
			)}
			{(results.target === "" && results.attacker === "") || (results.target === "No Damage" && results.attacker === "No Damage") || results.ram ? null : (
				<Row className="p-3 text-center">
					<Col>
						<p>NOTE: A maximum of half of a ship's oar factors can be destroyed by a single oar rake attack</p>
					</Col>
				</Row>
			)}
			<Row className="mt-3">
				<Col>
					<FormLabel htmlFor="target-size">Target's' Size Rating</FormLabel>
					<FormSelect id="target-size" value={targetSizeRating} onChange={(e) => setTargetSizeRating(parseInt(e.target.value))}>
						<option value={1}>Very Small</option>
						<option value={2}>Small</option>
						<option value={3}>Medium</option>
						<option value={4}>Large</option>
						<option value={5}>Very Large</option>
					</FormSelect>
				</Col>
				<Col>
					<FormLabel htmlFor="target-speed">Target's Speed</FormLabel>
					<FormControl id="target-speed" type="number" min={0} value={targetSpeed} onChange={(e) => setTargetSpeed(parseInt(e.target.value))} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormLabel htmlFor="attackers-size">Attacker's Size Rating</FormLabel>
					<FormSelect id="attackers-size" value={attackersSizeRating} onChange={(e) => setAttackersSizeRating(parseInt(e.target.value))}>
						<option value={1}>Very Small</option>
						<option value={2}>Small</option>
						<option value={3}>Medium</option>
						<option value={4}>Large</option>
						<option value={5}>Very Large</option>
					</FormSelect>
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormLabel htmlFor="attacker-move-rate">Attacker's Move Rate</FormLabel>
					<FormSelect id="attacker-move-rate" value={attackersMoveRate} onChange={(e) => setAttackersMoveRate(e.target.value)}>
						<option value="Maneuver">Maneuver Move Rate</option>
						<option value="Battle">Battle Move Rate</option>
						<option value="Ram">Ram Move Rate</option>
					</FormSelect>
				</Col>
				<Col>
					<FormLabel htmlFor="attacker-experience">Attacker's Experience Level</FormLabel>
					<FormSelect id="attacker-experience" value={attackingExperience} onChange={(e) => setAttackingExperience(e.target.value)}>
						<option value="IX">Inexperienced</option>
						<option value="EX">Experienced</option>
						<option value="VT">Vetran</option>
					</FormSelect>
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormLabel htmlFor="ram-value">Attacker's Ram Value</FormLabel>
					<FormControl id="ram-value" type="number" min={1} value={ramValue} onChange={(e) => setRamValue(parseInt(e.target.value))} />
				</Col>
				<Col>
					<FormLabel htmlFor="ram-modifier">Attaker's Ram Modifier (plus value)</FormLabel>
					<FormControl id="ram-modifier" type="number" min={0} value={ramModifier} onChange={(e) => setRamModifier(parseInt(e.target.value))} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormCheck type="checkbox" label="The attacker is without a ram (no-ram ship or has lost ram)" checked={isNoRamShip} onChange={(e) => setIsNoRamShip(e.target.checked)} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormCheck type="checkbox" label="Target is reduced to propulsion level C" checked={isC} onChange={(e) => setIsC(e.target.checked)} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormCheck type="checkbox" label="Target is drifting" checked={isDrifting} onChange={(e) => setIsDrifting(e.target.checked)} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormCheck type="checkbox" label="Target is grappled or reduced to propulsion level D" checked={isGrappledOrD} onChange={(e) => setIsGrappledOrD(e.target.checked)} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormLabel htmlFor="ram-rake-toggle" className="d-inline-block pe-2">Oar Rake</FormLabel>
					<FormCheck id="ram-rake-toggle" className="d-inline-block" type="switch" label="Ramming Attack" checked={isRamAttack} onChange={(e) => setIsRamAttack(e.target.checked)} />
				</Col>
			</Row>
			{isRamAttack ? (
				<>
					<Row className="mt-3">
						<Col>
							<FormLabel htmlFor="attack-dir">Attack Direction</FormLabel>
							<FormSelect id="attack-dir" value={ramAttackDir} onChange={(e) => setRamAttackDir(e.target.value)}>
								<option value="Side">Side</option>
								<option value="Bow">Bow</option>
								<option value="Stern">Sten</option>
							</FormSelect>
						</Col>
					</Row>
					<Row className="mt-3">
						<Col>
							<FormCheck type="checkbox" label="Attacker is has no Deck Crew" checked={isRamWithoutDeckCrew} onChange={(e) => setIsRamWitoutDeckCrew(e.target.checked)} />
						</Col>
					</Row>
				</>
			): (
				<>
					<Row className="mt-3">
						<Col>
							<FormLabel htmlFor="target-experience">Target's Experience Level</FormLabel>
							<FormSelect id="target-experience" value={targetExperience} onChange={(e) => setTargetExperience(e.target.value)}>
								<option value="IX">Inexperienced</option>
								<option value="EX">Experienced</option>
								<option value="VT">Vetran</option>
							</FormSelect>
						</Col>
					</Row>
					<Row className="mt-3">
						<Col>
							<FormCheck type="checkbox" label="Attacker is traveling in the same direction as target" checked={isSternRake} onChange={(e) => setIsSternRake(e.target.checked)} />
						</Col>
					</Row>
				</>
			)}
			<Row className="mt-3">
				<Col xs={12}>
					<button className="btn btn-primary" onClick={() => rollforAttack()}>Roll for {isRamAttack ? "Ram Attack" : "Oar Rake"}</button>
				</Col>
				<Col className="mt-3">
					<button className="btn btn-danger" onClick={() => setResults({ target: "", attacker: "", ram: true })}>Clear Result</button>
				</Col>
			</Row>
		</>
	);
}